import Api from '../_base';
import ApiSubscription from '../_subbase';
import cookie from 'react-cookies';
import axios from 'axios';

class SendNumberdApi {
	constructor() {
		this.urlBase = 'https://vivo.api.yalo.com.br';
		if (window.location.hostname === 'qa.yalo.com.br')
			this.urlBase = 'https://homol.yalo.com.br/vivo';
		if (window.location.hostname === 'localhost')
			this.urlBase = 'https://homol.yalo.com.br/vivo';
	}

	getConfig(path, auth) {
		const config = Object.assign(
			{
				url: path
			},
			this.options
		);

		if (auth) {
			let token = cookie.load('VivoToken');

			config.headers = Object.assign(
				{
					Authorization: 'bearer ' + token
				},
				config.headers
			);
		}

		return config;
	}

	post(path, data, auth = false) {
		path = this.urlBase + path;
		const config = {
			method: 'post',
			data,
			...this.getConfig(path, auth)
		};

		return axios(config).catch(this.notAuthenticated);
	}

	async loginVivo() {
		try {
			const response = await this.post('/token', {
				email: process.env.REACT_APP_ECOMMERCE_USER,
				password: process.env.REACT_APP_ECOMMERCE_PSW
			});
			cookie.save('VivoToken', response.data.token);
		} catch (err) { }
	}

	async sendNumber(data) {
		try {
			//const response = await Api.post('/check-phone/', { phone: data }, true);
			const response = await this.post('/check-phone', { phone: data }, true);
			return {
				data: response.data,
				status: response.status,
				statusText: response.statusText
			};
		} catch (err) {
			let error = err.response;
			return error;
		}
	}

	async sendPin(id, phone) {
		try {
			//const response = await Api.post('/check-phone/', { phone: data }, true);
			const response = await this.post(
				'/send-pin',
				{ phone: phone, productId: id },
				true
			);
			let hasError = ''
			if (response.status === 200) {
				hasError = false;
			} else {
				hasError = 'true1';
			}
			return hasError;
		} catch (err) {
			let error = err;
			return error;
		}
	}

	async validatePin(id, phone, pin) {
		try {
			//const response = await Api.post('/check-phone/', { phone: data }, true);
			const response = await this.post(
				'/validate-pin',
				{ phone: phone, productId: id, pin: pin },
				true
			);
			return {
				data: response.data,
				status: response.status,
				statusText: response.statusText
			};
		} catch (err) {
			let error = err;
			return error;
		}
	}
}

export default new SendNumberdApi();
//codigo do campo ta errado
// auterar o logo da vivo
// alterar a menssagem de erro do pin
